class Storage {
  constructor(prefix, { naming = 'prefix' }) {
    this.prefix = prefix;
    this.naming = naming;
  }

  getPath(key) {
    const path =
      this.naming === 'prefix'
        ? `${this.prefix}__${key}`
        : `${key}__${this.prefix}`;
    return path;
  }

  set(key, item) {
    window.localStorage.setItem(this.getPath(key), JSON.stringify(item));
  }

  get(key) {
    const value = window.localStorage.getItem(this.getPath(key));
    return value === null ? undefined : JSON.parse(value);
  }

  remove(key) {
    window.localStorage.removeItem(this.getPath(key));
  }
}

// TODO: add dependence on env
export default new Storage('praedias', {
  naming: 'dev' ? 'postfix' : 'prefix',
});
